import React from 'react';
import { Grid } from '@material-ui/core';
import { CommentModel, ReactionsType } from '../NewsfeedModels';
import ReactionAction from './ReactionAction';
import Reactions from '../Reactions';

const ExistingCommentActionBar = ({ comment, refresh }: { comment: CommentModel; refresh: () => void }) => {
    return (
        <Grid
            container
            item
            xs={12}
            direction="row"
            alignItems="center"
            justify="space-between"
            wrap="nowrap"
            style={{ marginLeft: 60, marginRight: 20, marginBottom: 10, marginTop: 10 }}
        >
            {(Object.keys(comment.reactions) as ReactionsType[]).map((reaction) => (
                <ReactionAction
                    key={reaction}
                    item={comment}
                    reactionType={reaction}
                    itemType="comment"
                    refresh={refresh}
                />
            ))}
            <Reactions reactions={comment.reactions} />
        </Grid>
    );
};

export default ExistingCommentActionBar;
